import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function load (path) {
  return () => import(`@/components/${path}`)
}

const routes = [
  {
    path: '/',
    component: load('home/Index')
  },
  {
    path: '/company',
    component: load('company/Index')
  },
  {
    path: '/news',
    component: load('news/Index')
  },
  {
    path: '/news/:id',
    component: load('news/NewsDetail')
  },
  {
    path: '/product',
    component: load('product/Index')
  },
  {
    path: '/product/:id',
    component: load('product/Detail')
  },
  {
    path: '/profile',
    component: load('profile/Index'),
    children: [
      {
        path: 'basic',
        component: load('profile/Basic')
      },
      // {
      //   path: 'assets',
      //   component: load('profile/Assets')
      // },
      {
        path: 'risks',
        component: load('profile/Risks')
      }
    ]
  },
  {
    path: '/profile/risks/:id',
    component: load('profile/RiskDetail')
  },
  {
    path: '/profile/review',
    component: load('profile/Review')
  },
  {
    path: '/profile/review/check',
    component: load('profile/ReviewCheck')
  },
  {
    path: '/profile/login',
    component: load('profile/Login')
  },
  {
    path: '/profile/identity',
    component: load('profile/Identity')
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router



// WEBPACK FOOTER //
// ./src/utils/router.js